import FilterMultiSelectGroup from './FilterMultiSelectGroup';
import type { KpiGroup, KpiGroupsProps } from './FilterMultiSelectGroup';

export default function FilterKpiGroupsMenu<Id extends string>({
  groups,
  kpis,
  activeIds,
  onGroupSelectionChange,
  iconMap,
}: KpiGroupsProps<Id> & { groups: KpiGroup<Id>[] }) {
  return (
    <div className="flex shrink-0 flex-wrap items-center gap-2">
      {groups.map((group) => (
        <FilterMultiSelectGroup
          key={group.id}
          group={group}
          kpis={kpis}
          activeIds={activeIds}
          onGroupSelectionChange={onGroupSelectionChange}
          iconMap={iconMap}
        />
      ))}
    </div>
  );
}
